import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { ImageDb } from '../redux/imageDbSlice';

const useOneImageDb = (imageId: string | undefined): ImageDb | undefined => {
  const imageDb = useSelector((state: RootState) => state.imageDb);
  const value = imageId ? imageDb.images[imageId] : undefined;

  return value;
}

export default useOneImageDb;
